import {
  ClickAwayListener,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../_helpers/hooks'
import { getLanguages, translation, translationData } from '../../slices/translationSlice'
import { LanguageIcon } from '../icons'

const LanguageSelector = () => {
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const translationState = useAppSelector(translationData)
  const { selectedLanguage } = translationState
  const [selectedLang, setSelectedLang] = useState(selectedLanguage ?? 'en')
  const anchorRef = useRef<HTMLDivElement>(null)
  const { languages } = useAppSelector(translationData)
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!languages?.length) {
      dispatch(getLanguages())
    }
  }, [languages?.length, dispatch])
  useEffect(() => {
    setSelectedLang(selectedLanguage)
  }, [selectedLanguage])

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }
    setOpen(false)
  }

  const handleLanguageSelect = (languageCode: string) => {
    setSelectedLang(languageCode)
    dispatch(translation(languageCode ?? 'en'))
    setOpen(false)
  }
  return (
    <>
      <Stack
        direction={'row'}
        spacing={0.5}
        ref={anchorRef}
        onClick={handleToggle}
        sx={{ cursor: 'pointer' }}
      >
        <LanguageIcon height='24' width='24' />
        <Typography variant='h4' color={theme.palette.secondary.main}>
          {selectedLang?.toUpperCase()}
        </Typography>
      </Stack>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement='bottom-start'
        sx={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={3} sx={{ minWidth: 150, mt: 1 }}>
            <List>
              {languages.map((language) => (
                <ListItem key={language.lang_code} disablePadding>
                  <ListItemButton onClick={() => handleLanguageSelect(language.lang_code)}>
                    <ListItemText
                      primary={language.language}
                      primaryTypographyProps={{ variant: 'body2' }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

export default LanguageSelector
